"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.picker.search.mode': 'Modalità di Ricerca',
    'knowledge.picker.search.knowledge': 'Voci di Conoscenza',
    'knowledge.picker.search.projects': 'Progetti',
    'knowledge.picker.search.knowledge.label': 'Cerca Voci di Conoscenza - assegna conoscenza all\'avatar',
    'knowledge.picker.search.knowledge.placeholder': 'Cerca voci di conoscenza...',
    'knowledge.picker.search.projects.label': 'Cerca Progetti - assegna progetto all\'avatar',
    'knowledge.picker.search.projects.placeholder': 'Cerca progetti...',
    'knowledge.picker.search.clear': 'Cancella ricerca',
    'knowledge.picker.selected.knowledge': 'Voci di Conoscenza Selezionate',
    'knowledge.picker.selected.projects': 'Progetti Selezionati',
    'knowledge.picker.table.name': 'Nome',
    'knowledge.picker.table.project': 'Progetto',
    'knowledge.picker.table.format': 'Formato',
    'knowledge.picker.table.size': 'Dimensione',
    'knowledge.picker.table.description': 'Descrizione',
    'knowledge.picker.remove': 'Rimuovi',
    'knowledge.picker.confirmRemove': 'Sei sicuro di voler rimuovere questa voce di conoscenza?',
    'knowledge.picker.no.results': 'Nessun elemento trovato',
    'knowledge.picker.1to1mode': 'Modalità 1:1 (Contenuto completo)',
    'knowledge.picker.tooltip': 'Scegli file per l\'assistente IA da utilizzare o aggiungi i tuoi',
};
